import React from 'react';
import { Button } from '../ui/Button';
export function HeroSection() {
  return <section className="relative flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#F8F5FF] via-[#FDFCFF] to-[#FAFAFA] pt-28 pb-16 lg:pt-32 lg:pb-20" data-id="element-112">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-113">
        <h1 className="text-[2.25rem] sm:text-[3rem] md:text-[3.5rem] lg:text-[4.25rem] font-bold text-[#1A1A2E] leading-[1.1] tracking-tight mb-4" data-id="element-114">
          Вы <span className="text-[#7C4DFF]" data-id="element-115">устали от&nbsp;операционки</span>{' '}
          в&nbsp;детском саду. Мы&nbsp;знаем как вас вытащить
        </h1>

        <div className="mb-8 space-y-1" data-id="element-116">
          <p className="text-base sm:text-lg text-gray-400 leading-relaxed" data-id="element-117">
            Meelo — система управления садом.
          </p>
          <p className="text-base sm:text-lg text-gray-600 font-semibold leading-relaxed" data-id="element-118">
            Подключим, обучим и внедрим за 2 дня.
          </p>
        </div>

        <a href="#solutions" data-id="element-119">
          <Button size="lg" className="text-base font-semibold tracking-widest uppercase px-14 py-4 rounded-2xl shadow-lg transition-all" data-id="element-120">
            Посмотреть как
          </Button>
        </a>
      </div>
    </section>;
}